var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('Banner'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('h3',[_vm._v("历史版本")])])
}]

export { render, staticRenderFns }